import React, {Component} from 'react';
import moment from 'moment';

class Review extends Component {

    render(){
        let {profile} = this.props;
        return (
            <div className="tab-content" style={{paddingBottom: '0px'}}>
                <div className="tab-pane active" id="tab6">
                    <div className="form-section">
                        <div className="panel-group" id="accordion">
                            <div className="panel customPanel">
                                <div className="panel-heading border-bottom">
                                    <h4 className="panel-title">
                                        <a data-toggle="collapse" data-parent="#accordion" href="#collapse1" aria-expanded="false" className="collapsed">Basic Info</a>
                                    </h4>
                                    <a href="dontgo" onClick={e => {
                                        e.preventDefault();
                                        this.props.setStep(1);
                                    }} className="btn btn-default">Edit</a>
    
                                </div>
                                <div id="collapse1" className="panel-collapse collapse" aria-expanded="false">
                                    <div className="panel-body">
                                        <p className="sm-top20 sm-bottom0 text-pink">General Information</p>
                                        <h3 className="SummaryItem"><span>Name</span> {profile.name} {profile.lname}</h3>
                                        <div className="row">
                                            <div className="col-sm-3">
                                                <h3 className="SummaryItem"><span>Email</span>{profile.email}</h3>
                                            </div>
                                            <div className="col-sm-3">
                                                <h3 className="SummaryItem"><span>Gender</span> {profile.gender}</h3>
                                            </div>
                                            <div className="col-sm-3">
                                                <h3 className="SummaryItem"><span>Birthday</span> {moment(profile.birthdate).format('MMM DD YYYY')}</h3>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <h3 className="SummaryItem"><span>Address</span>{profile.address1}{profile.address2 ? ' ' + profile.address2 : ''}, {profile.city}, {profile.district} ({profile.postalCode})</h3>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <h3 className="SummaryItem"><span>Contact Information</span> +{profile.phonecountry} {profile.phone} ({profile.phonetype})</h3>
                                            </div>
                                        </div>
                                        <p className="sm-top20 sm-bottom0 text-pink">Emergency Contact Information</p>
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <h3 className="SummaryItem"><span>Contact Person</span> {profile.ecname}</h3>
                                            </div>
                                            <div className="col-sm-4">
                                                <h3 className="SummaryItem"><span>Relationship</span> {profile.ecrel}</h3>
                                            </div>
                                            <div className="col-sm-4">
                                                <h3 className="SummaryItem"><span>Contact Number</span> +{profile.eccountry} {profile.ecnumber} ({profile.ectype})</h3>
                                            </div>
                                        </div>
                                        
                                        {profile.prel &&
                                            <div>
                                                <p className="sm-top20 sm-bottom0 text-pink">Parent/Guardian's Information</p>
                                                <div className="row">
                                                    <div className="col-sm-4">
                                                        <h3 className="SummaryItem"><span>Contact Person</span> {profile.pname}</h3>
                                                    </div>
                                                    <div className="col-sm-4">
                                                        <h3 className="SummaryItem"><span>Relationship</span> {profile.prel}</h3>
                                                    </div>
                                                    <div className="col-sm-4">
                                                        <h3 className="SummaryItem"><span>Contact Number</span> +{profile.pcountry} {profile.pnumber}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="panel customPanel">
                                <div className="panel-heading border-bottom">
                                    <h4 className="panel-title">
                                        <a data-toggle="collapse" data-parent="#accordion" href="#collapse2" className="collapsed" aria-expanded="false">Education</a>
                                    </h4>
                                    <a href="dontgo" onClick={e => {
                                        e.preventDefault();
                                        this.props.setStep(2);
                                    }} className="btn btn-default">Edit</a>
                                </div>
                                <div id="collapse2" className="panel-collapse collapse" aria-expanded="false">
                                    <div className="panel-body">
                                        <p className="sm-top20 sm-bottom0 text-pink">Current Education</p>
                                        <div className="row">
                                            <div className="col-sm-3">
                                                <h3 className="SummaryItem"><span>Currently In School</span> {profile.education[0].currentEducation}</h3>
                                            </div>
                                            <div className="col-sm-3">
                                                <h3 className="SummaryItem"><span>Expected cGPA</span> {profile.education[0].currentEducation ? profile.education[0].userCGPA : 'NA'}</h3>
                                            </div>
                                            <div className="col-sm-3">
                                                <h3 className="SummaryItem"><span>Expected Completion</span> {profile.education[0].currentEducation ? profile.education[0].yearOfStudy : 'NA'}</h3>
                                            </div>
                                            <div className="col-sm-3">
                                                <h3 className="SummaryItem"><span>Field of Study</span>{profile.education[0].currentEducation ? profile.education[0].majorField : 'NA'}</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="panel-body">
                                        <p className="sm-top20 sm-bottom0 text-pink">Previous Education</p>
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <h3 className="SummaryItem"><span>Highest Level of Education</span> {profile.education[0].finishedDegree}</h3>
                                            </div>
                                            <div className="col-sm-4">
                                                <h3 className="SummaryItem"><span>Degree Completion Year</span>{profile.education[0].finishedDegreeDate}</h3>
                                            </div>
                                            <div className="col-sm-4">
                                                <h3 className="SummaryItem"><span>CGPA</span> {profile.education[0].cgpa}</h3>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <h3 className="SummaryItem"><span>Field of Study</span>{profile.education[0].finishedDegreeName}</h3>
                                            </div>
                                            <div className="col-sm-8">
                                                <h3 className="SummaryItem"><span>Institution</span> {profile.education[0].institution}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel customPanel">
                                <div className="panel-heading border-bottom">
                                    <h4 className="panel-title">
                                        <a data-toggle="collapse" data-parent="#accordion" href="#collapse3" className="collapsed" aria-expanded="false">Environment</a>
                                    </h4>
                                    <a href="dontgo" onClick={e => {
                                        e.preventDefault();
                                        this.props.setStep(3);
                                    }} className="btn btn-default">Edit</a>
                                </div>
                                <div id="collapse3" className="panel-collapse collapse" aria-expanded="false">
                                    <div className="panel-body">
                                        <p className="sm-top20 sm-bottom0 text-pink">During preparation, expected number of hours you will spend on:</p>
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <h3 className="SummaryItem"><span>Work/Job</span> {profile.personal.workingHours} Hours</h3>
                                            </div>
                                            <div className="col-sm-4">
                                                <h3 className="SummaryItem"><span>Study for school</span>{profile.personal.schoolHours} Hours</h3>
                                            </div>
                                            <div className="col-sm-4">
                                                <h3 className="SummaryItem"><span>Extracurricular Activities</span> {profile.personal.activityHours} Hours</h3>
                                            </div>
                                        </div>
    
                                        <p className="sm-top20 sm-bottom0 text-pink">Environment:</p>
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <h3 className="SummaryItem"><span>You Live</span> {profile.personal.living}</h3>
                                            </div>
                                            <div className="col-sm-4">
                                                <h3 className="SummaryItem"><span>Study Space at Home</span>{profile.personal.room}</h3>
                                            </div>
                                            <div className="col-sm-4">
                                                <h3 className="SummaryItem"><span>People Dependent on You</span> {profile.personal.dependents}</h3>
                                            </div>
                                            <div className="col-sm-12">
                                                <h3 className="SummaryItem"><span>Other Details</span> {profile.personal.additional}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                            <div className="panel customPanel">
                                <div className="panel-heading border-bottom">
                                    <h4 className="panel-title">
                                        <a data-toggle="collapse" data-parent="#accordion" href="#collapse4" className="collapsed" aria-expanded="false">Official Test</a>
                                    </h4>
                                    <a href="dontgo" onClick={e => {
                                        e.preventDefault();
                                        this.props.setStep(4);
                                    }} className="btn btn-default">Edit</a>
                                </div>
                                <div id="collapse4" className="panel-collapse collapse" aria-expanded="false">
                                    <div className="panel-body">
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <h3 className="SummaryItem"><span>Studied for This Test Before</span> {profile.onboardingTest.studiedLSAT === "yes" ? 'Yes' : 'No'}</h3>
                                            </div>
                                            <div className="col-sm-4">
                                                <h3 className="SummaryItem"><span>Already Taken Official Test</span>{profile.onboardingTest.tokeLSAT ? 'Yes' : 'No'}</h3>
                                            </div>
                                            <div className="col-sm-12">
                                                <h3 className="SummaryItem"><span>Resource You Have Used</span> {profile.onboardingTest.resources}</h3>
                                            </div>
                                        </div>
                                        {profile.CourseUser ?
                                            profile.CourseUser[0] ?
                                            profile.CourseUser[0].officialTest ?
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <h3 className="SummaryItem"><span>{profile.CourseUser[0].officialTest.name} Score</span> {profile.CourseUser[0].officialTest.score}</h3>
                                                    </div>
                                                    {profile.CourseUser[0].officialTest.sections.map((section, i) => {
                                                        return (
                                                            <div className="col-sm-4" key={i}>
                                                                <h3 className="SummaryItem"><span>{section.name} Score</span>{section.score}</h3>
                                                            </div>
                                                        )
                                                    })
                                                    }
                                                    
                                                </div>
                                            : null
                                            : null
                                        : null}
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <h3 className="SummaryItem"><span>Ideal Target Score</span> {profile.onboardingTest.target}</h3>
                                            </div>
                                            <div className="col-sm-4">
                                                <h3 className="SummaryItem"><span>Minimum Target Score</span>{profile.onboardingTest.minimum}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel customPanel">
                                <div className="panel-heading border-bottom">
                                    <h4 className="panel-title">
                                        <a data-toggle="collapse" data-parent="#accordion" href="#collapse5" className="collapsed" aria-expanded="false">Open Response</a>
                                    </h4>
                                    <a href="dontgo" onClick={e => {
                                        e.preventDefault();
                                        this.props.setStep(3);
                                    }} className="btn btn-default">Edit</a>
                                </div>
                                <div id="collapse5" className="panel-collapse collapse" aria-expanded="false">
                                    <div className="panel-body">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <h3 className="SummaryItem"><span>Details</span> {profile.personal.additional2}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        )
    }
}

export default Review;


// WEBPACK FOOTER //
// ./src/components/onBoarding/Review.js